(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* Per-visit product mixer for collection pages.
     Shopify's native collection sorting has no random mode, so we sample
     rendered section pages and reuse the existing Liquid product-card markup. */
  (function () {
    const MAX_RANDOM_PRODUCTS = 1000;
    const PRODUCTS_PER_PAGE = 50;
    const FETCH_BATCH_SIZE = 4;
    const GRID_INITIALIZED_ATTR = 'data-random-plp-initialized';

    function shuffleArray(arr) {
      const a = arr.slice();
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    }

    function shouldRandomizePlp() {
      const url = new URL(window.location.href);

      if (!url.pathname.match(/^\/collections\/[^/]+/)) return false;
      if (window.Shopify && window.Shopify.designMode) return false;

      // Respect intentional customer sorting such as price low-to-high.
      return !url.searchParams.get('sort_by');
    }

    function getGrid() {
      return document.querySelector('.product-grid__list, [ref="productGrid"], ul.product-grid');
    }

    function getItems(grid) {
      return Array.from(grid.querySelectorAll('.product-grid__item'));
    }

    function getSectionId(grid) {
      return grid.closest('results-list')?.getAttribute('section-id') || '';
    }

    function getCurrentPage() {
      const page = Number(new URL(window.location.href).searchParams.get('page') || 1);
      return Number.isFinite(page) && page > 0 ? page : 1;
    }

    function buildSectionPageUrl(sectionId, page) {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', sectionId);
      url.searchParams.set('page', String(page));
      return url.toString();
    }

    function getRandomPageOrder(totalPages, currentPage) {
      const pages = Array.from({ length: totalPages }, (_, index) => index + 1);
      const otherPages = pages.filter(page => page !== currentPage);

      return [currentPage, ...shuffleArray(otherPages)];
    }

    function parseProductsFromSectionHTML(html, page) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return Array.from(doc.querySelectorAll('.product-grid__item')).map(item => {
        const imported = document.importNode(item, true);
        imported.dataset.randomSourcePage = String(page);
        return imported;
      });
    }

    async function fetchPageItems(sectionId, page) {
      const response = await fetch(buildSectionPageUrl(sectionId, page), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (!response.ok) return [];

      return parseProductsFromSectionHTML(await response.text(), page);
    }

    async function buildPoolFromPages(sectionId, pagesToFetch, currentItems) {
      let pool = dedupeProducts(currentItems);

      for (let index = 0; index < pagesToFetch.length && pool.length < MAX_RANDOM_PRODUCTS; index += FETCH_BATCH_SIZE) {
        const batchPages = pagesToFetch.slice(index, index + FETCH_BATCH_SIZE);
        const batchResults = await Promise.all(batchPages.map(page => fetchPageItems(sectionId, page).catch(() => [])));
        const fetchedItems = batchResults.flat();
        pool = dedupeProducts([...pool, ...fetchedItems]).slice(0, MAX_RANDOM_PRODUCTS);
      }

      return pool;
    }

    function dedupeProducts(items) {
      const seen = new Set();

      return items.filter(item => {
        const key = item.dataset.productId || item.id || item.querySelector('a[href*="/products/"]')?.getAttribute('href');
        if (!key || seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    }

    function renderRandomSet(grid, pool) {
      if (!pool.length) return;

      const pageSize = Math.max(1, getItems(grid).length || PRODUCTS_PER_PAGE);
      const selected = shuffleArray(pool).slice(0, Math.min(pageSize, pool.length));

      getItems(grid).forEach(el => el.classList.add('product-grid__item--shuffling'));

      setTimeout(() => {
        grid.replaceChildren(...selected);
        selected.forEach(el => el.classList.remove('product-grid__item--shuffling'));
      }, 220);
    }

    function setButtonState(button, state, poolSize) {
      if (!button) return;

      const icon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" width="14" height="14"><polyline points="16 3 21 3 21 8"/><line x1="4" y1="20" x2="21" y2="3"/><polyline points="21 16 21 21 16 21"/><line x1="15" y1="15" x2="21" y2="21"/></svg>';

      if (state === 'loading') {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.innerHTML = icon + ' Mixing products...';
        return;
      }

      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.innerHTML = icon + (poolSize ? ' Shuffle ' + poolSize + ' picks' : ' Shuffle picks');
    }

    async function buildRandomPool(grid, button) {
      const sectionId = getSectionId(grid);
      const currentItems = getItems(grid);
      const totalPages = Number(grid.dataset.lastPage || 1);

      if (!sectionId || !totalPages || totalPages < 2) {
        return dedupeProducts(currentItems);
      }

      setButtonState(button, 'loading');

      const currentPage = Math.min(getCurrentPage(), totalPages);
      const pages = getRandomPageOrder(totalPages, currentPage);
      const pagesToFetch = pages.filter(page => page !== currentPage);
      return buildPoolFromPages(sectionId, pagesToFetch, currentItems);
    }

    async function randomizeGrid(grid, button, forceReload) {
      if (!grid || grid.dataset.randomPlpLoading === 'true') return;

      grid.dataset.randomPlpLoading = 'true';

      try {
        if (forceReload || !grid.randomPlpPool) {
          grid.randomPlpPool = await buildRandomPool(grid, button);
        }

        renderRandomSet(grid, grid.randomPlpPool);
        setButtonState(button, 'ready', grid.randomPlpPool.length);
      } finally {
        grid.dataset.randomPlpLoading = 'false';
      }
    }

    function injectShuffleButton(grid) {
      const existingButton = document.querySelector('.collection-shuffle-btn');
      if (existingButton) {
        const freshButton = existingButton.cloneNode(true);
        existingButton.replaceWith(freshButton);
        return freshButton;
      }

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'collection-shuffle-btn';
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" width="14" height="14"><polyline points="16 3 21 3 21 8"/><line x1="4" y1="20" x2="21" y2="3"/><polyline points="21 16 21 21 16 21"/><line x1="15" y1="15" x2="21" y2="21"/></svg> Shuffle picks';
      const wrap = document.createElement('div');
      wrap.className = 'collection-shuffle-controls';
      wrap.appendChild(btn);
      grid.parentElement.insertBefore(wrap, grid);
      return btn;
    }

    function initRandomPlp() {
      if (!shouldRandomizePlp()) return;

      const grid = getGrid();
      if (!grid || grid.hasAttribute(GRID_INITIALIZED_ATTR)) return;

      grid.setAttribute(GRID_INITIALIZED_ATTR, '');
      const btn = injectShuffleButton(grid);
      if (btn) btn.addEventListener('click', () => randomizeGrid(grid, btn, false));

      window.setTimeout(() => randomizeGrid(grid, btn, true), 120);
    }

    let initTimer;
    function scheduleInit() {
      window.clearTimeout(initTimer);
      initTimer = window.setTimeout(initRandomPlp, 90);
    }

    document.addEventListener('DOMContentLoaded', initRandomPlp, { once: true });

    new MutationObserver(mutations => {
      if (mutations.some(mutation => {
        return Array.from(mutation.addedNodes).some(node => {
          return node instanceof Element && (node.matches?.('ul.product-grid') || node.querySelector?.('ul.product-grid'));
        });
      })) {
        scheduleInit();
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
